import React, { useState } from "react";
import { useEffect } from "react";
import { API } from "../App";
import SinglePostCarousel from "../components/SinglePostCarousel";
import { useNavigate, Link, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
function PostDisplay() {
  let navigate = useNavigate();
  const { id, permalink } = useParams();
  const [post, setPost] = useState({
    title: "",
    description: "",
  });
  const [category, setCategory] = useState({});
  const fetchPost = async () => {
    try {
      const response = await fetch(`${API}/public/news/${id}`)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            switch (res.status) {
              case 401:
                throw new Error(
                  "You are not authorized to perform this action"
                );
              case 404:
                throw new Error("The resource you requested was not found");
              default:
                console.log(res.status);
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (response) {
        setPost(response);
        fetchCategory(response.CategoryId);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const fetchCategory = async (categoryId) => {
    try {
      const response = await fetch(`${API}/public/category/${categoryId}`)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            switch (res.status) {
              case 401:
                throw new Error(
                  "You are not authorized to perform this action"
                );
              case 404:
                throw new Error("The resource you requested was not found");
              default:
                console.log(res.status);
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (response) {
        setCategory(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    fetchPost();
  }, []);
  return (
    <>
      <div className="postdisplay">
        <button onClick={() => navigate(-1)} className="postdisplay__backBtn">
          <ArrowBackIosNewIcon />
        </button>
        {category.title && (
          <Link
            className="postdisplay__categoryName"
            to={`/categorias/${category.title
              ?.split(" ")
              .join("-")
              .toLowerCase()}/${post.CategoryId}`}
          >
            {category.title}
          </Link>
        )}

        <div className="postdisplay__header">
          <h1 className="postdisplay__title">{post.title}</h1>
          <div className="postdisplay__images">
            {post.contents?.length > 0 && <SinglePostCarousel post={post} />}
          </div>
        </div>
        <div className="postdisplay__upper">
          <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
        </div>
        <div className="postdisplay__lower">
          <div className="postdisplay__shareBar">
            <h1>Compartir noticia en:</h1>
            <div className="postdisplay__buttonGroup">
              <button
                className="postdisplay__shareBtn"
                onClick={() => {
                  window.FB.ui(
                    {
                      display: "popup",
                      method: "share",
                      href:
                        "http://ligafutbolriocuarto.com" +
                        window.location.pathname,
                    },
                    function (response) {}
                  );
                }}
              >
                <FacebookIcon />
              </button>
              <a
                href={`https://api.whatsapp.com/send?text=${
                  "http://ligafutbolriocuarto.com" + window.location.pathname
                }`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noreferrer"
                className="postdisplay__shareLink"
              >
                <WhatsAppIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PostDisplay;
